export default {
    verificar_telefono:false,
    mensaje_verificar_telefono: ""
}